import { Link } from "react-router-dom";
import { useLang } from "../i18n/LangContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <section className="container-x py-32 text-left" data-testid="not-found">
      <h1 className="text-5xl font-extrabold uppercase">{t("common.notFound")}</h1>
      <Link to="/" className="btn-yellow mt-8 px-6 py-3">{t("common.goHome")}</Link>
    </section>
  );
}
